export * from './useIndexQuery.types';
export { default as useIndexQuery } from './useIndexQuery';
